import { $http } from "@/utils/https";

import {
    GET_LIST,
    GET_CARDS_LIST,
    SET_NEW_PAYMENTS_METHOD,
    REPLACE_PAYMENTS_METHOD,
    SET_DEFAULT_PAYMENT_METHOD,
    DELETE_CARD
} from "./types/action-types";

import {
    CHANGE_SKIP,
    GET_LIST_LOADING,
    SET_LIST,
    SET_LIST_LENGTH,
    GET_CARDS_LIST_LOADING,
    SET_CARDS_LIST,
    SET_PROVIDER,
    SET_NEW_PAYMENTS_METHOD_LOADING,
    SET_DEFAULT_PAYMENT_METHOD_LOADING,
    CHANGE_POPUP_DELETE_CARD,
    DELETE_CARD_LOADING,
    CHANGE_OPEN_NOTIFICATION
} from "./types/mutation-types";

const state = {
    provider                        : "fondy",
    list                            : [],
    listLength                      : 0,
    isListLoading                   : false,
    skip                            : 0,
    limit                           : 5,
    cardsList                       : [],
    isCardsListLoading              : false,
    isNewPaymentMethodLoading       : false,
    isDefaultPaymentMethodLoading   : false,
    isDeletePaymentMethodLoading    : false,
    showPopupDelete                 : false,
    deletedCard                     : {},
    openNotification                : false
};

const getters = {
    provider                        : (state) => state.provider,
    list                            : (state) => state.list,
    listLength                      : (state) => state.listLength,
    isListLoading                   : (state) => state.isListLoading,
    skip                            : (state) => state.skip,
    limit                           : (state) => state.limit,
    dateFrom                        : (state) => state.dateFrom,
    dateTo                          : (state) => state.dateTo,
    cardsList                       : (state) => state.cardsList,
    isCardsListLoading              : (state) => state.isCardsListLoading,
    isNewPaymentMethodLoading       : (state) => state.isNewPaymentMethodLoading,
    isDefaultPaymentMethodLoading   : (state) => state.isDefaultPaymentMethodLoading,
    isDeletePaymentMethodLoading    : (state) => state.isDeletePaymentMethodLoading,
    showPopupDelete                 : (state) => state.showPopupDelete,
    deletedCard                     : (state) => state.deletedCard,
    openNotification                : (state) => state.openNotification
};

const actions = {
    [GET_LIST]                  : async ({ commit }, payload) => {
        try {
            commit(GET_LIST_LOADING, true);

            const response = await $http.get(
                `${process.env.VUE_APP_ROOT_PAYMENT}user/transactions?include=currency,wallet&limit=${state.limit}&skip=${state.skip}&filters[date_from]=${payload.dateFrom}&filters[date_to]=${payload.dateTo}`
            );

            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);

            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(GET_LIST_LOADING, false);
        }
    },
    [GET_CARDS_LIST]            : async ({ commit }, payload) => {
        try {
            if(typeof payload !== 'function'){
                commit(GET_CARDS_LIST_LOADING, true);
            }
            
            const response = await $http.get(
                `${process.env.VUE_APP_ROOT_PAYMENT}card/my`
            );
            
            if(typeof payload === 'function'){
                if(response.data && 'data' in response.data && 'items' in response.data.data){
                    payload(response.data.data.items);
                }else{
                    payload([]);
                }
                
                return [];
            }
            
            commit(SET_CARDS_LIST   , response.data.data.items);
            commit(SET_PROVIDER     , response.data.data.provider);
            
            return response;
        } catch (e) {
            //throw e;
            
            if(typeof payload === 'function'){
                payload([]);
            }
            
            return [];
        } finally {
            if(typeof payload !== 'function'){
                commit(GET_CARDS_LIST_LOADING, false);
            }
            
            return [];
        }
    },
    [SET_NEW_PAYMENTS_METHOD]   : async ({ commit }, payload) => {
        try {
            commit(SET_NEW_PAYMENTS_METHOD_LOADING, true);
            
            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_PAYMENT}card/create`,
                {
                    country     : (payload && typeof payload.country != "undefined") ? payload.country : "",
                    number      : (payload && typeof payload.number != "undefined") ? payload.number : "",
                    month       : (payload && typeof payload.month != "undefined") ? payload.month : "",
                    year        : (payload && typeof payload.year != "undefined") ? payload.year : "",
                    cvv         : (payload && typeof payload.cvv != "undefined") ? payload.cvv : "",
                    is_default  : (payload && typeof payload.is_default != "undefined") ? payload.is_default : false
                }
            );
            
            if (response.status == 200 || response.status == 204) {
                return response.data;
            }
            
            return [];
        } catch (e) {
            throw e;
        } finally {
            commit(SET_NEW_PAYMENTS_METHOD_LOADING, false);
        }
    },
    [REPLACE_PAYMENTS_METHOD]   : async ({ commit }, card_id) => {
        try {
            commit(SET_NEW_PAYMENTS_METHOD_LOADING, true);
            
            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_PAYMENT}card/replace`,
                {
                    id     : card_id
                }
            );
            
            if (response.status == 200 || response.status == 204) {
                return response.data;
            }
            
            return [];
        } catch (e) {
            throw e;
        } finally {
            commit(SET_NEW_PAYMENTS_METHOD_LOADING, false);
        }
    },
    [SET_DEFAULT_PAYMENT_METHOD]: async ({ commit }, payload) => {
        try {
            commit(SET_DEFAULT_PAYMENT_METHOD_LOADING, true);
            
            await $http.patch(
                `${process.env.VUE_APP_ROOT_PAYMENT}card/default/${payload}`
            );
        } catch (e) {
            throw e;
        } finally {
            commit(SET_DEFAULT_PAYMENT_METHOD_LOADING, false);
        }
    },
    [DELETE_CARD]               : async ({ commit }, payload) => {
        try {
            commit(DELETE_CARD_LOADING, true);
            
            await $http.delete(`${process.env.VUE_APP_ROOT_PAYMENT}card/${payload.id}`);
        } catch (e) {
            throw e;
        } finally {
            //commit(CHANGE_POPUP_DELETE_CARD , false);
            commit(DELETE_CARD_LOADING      , false);
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (data.length) {
            state.list.push(...data);
        } else {
            state.list = data;
        }
        
        //state.list = data;
    },
    [GET_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [CHANGE_SKIP](state, status = true) {
        if (status) {
            state.skip += state.limit;
        } else {
            state.skip = 0;
        }
    },
    [SET_CARDS_LIST](state, data) {
        state.cardsList = data ? data : [];
    },
    [SET_PROVIDER](state, data) {
        state.provider = data;
    },
    [GET_CARDS_LIST_LOADING](state, status) {
        state.isCardsListLoading = status;
    },
    [SET_NEW_PAYMENTS_METHOD_LOADING](state, status) {
        state.isNewPaymentMethodLoading = status;
    },
    [SET_DEFAULT_PAYMENT_METHOD_LOADING](state, status) {
        state.isDefaultPaymentMethodLoading = status;
    },
    [CHANGE_POPUP_DELETE_CARD](state, status) {
        state.showPopupDelete   = status[0];
        state.deletedCard       = status[1];
    },
    [DELETE_CARD_LOADING](state, status) {
        state.isDeletePaymentMethodLoading = status;
    },
    [CHANGE_OPEN_NOTIFICATION](state, value) {
        state.openNotification = value === true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
